import { DEBUG, DEFAULT_PREFS } from "./config";
import { getAppCardNode } from "./appCardDefault";
import { DomHelper } from "./domHelper";
import { getBackendData } from "./xhrbackend";
function renderContent(cardNode, username, bearerToken, injectNode, hostname, idString = 'rudi-laps') {
    getBackendData("", `/laps/${username}/psw/${hostname}`, "GET", "application/json", bearerToken, function (response) {
        const formNode = injectNode.querySelector('.rudi-form-input-group');
        if (formNode)
            formNode.classList.add('disabled');
        const productResponseData = JSON.parse(response.target.response);
        const lapsItem = productResponseData[0];
        const medProDataNode = DomHelper.appendNode(injectNode, 'div', ['rudi-medpro-data']);
        if (response.target.status == 403) {
            DomHelper.appendNode(medProDataNode, 'div', [], [], `Zugriff verweigert`);
        }
        else if (response.target.status == 424) {
            DomHelper.appendNode(medProDataNode, 'div', [], [], `Backend steht nicht bereit`);
        }
        else if (productResponseData.length < 1) {
            DomHelper.appendNode(medProDataNode, 'div', [], [], `Zu diesem Hostname wurde keine Daten gefunden`);
        }
        else {
            DomHelper.appendNode(medProDataNode, 'div', [], [], `Hostname: ${lapsItem.cn}`);
            const pswNode = DomHelper.appendNode(medProDataNode, 'div', ['rudi-voucher'], []);
            DomHelper.appendNode(pswNode, 'span', ['rudi-voucher-code'], [], `${lapsItem["ms-Mcs-AdmPwd"]}`);
            cardNode.classList.add('app-open');
            cardNode.classList.remove('rudi-max-height');
        }
        DomHelper.appendCloseSection(cardNode, (event) => {
            cardNode.classList.remove('app-open');
            cardNode.classList.add('rudi-max-height');
            medProDataNode.remove();
            if (formNode) {
                formNode.classList.remove('disabled');
            }
        });
    });
}
export function appLaps(globalStore, username, bearerToken, parentNode, app, userResponse) {
    if (DEBUG)
        console.log("-->appLaps");
    const additionalClassList = [];
    const idString = 'rudi-laps';
    if (!userResponse.odDeskPreferences)
        userResponse.odDeskPreferences = DEFAULT_PREFS;
    const cardNode = getAppCardNode(parentNode, app, username, userResponse.odDeskPreferences, bearerToken, false, additionalClassList, null, true);
    const injectNode = cardNode.querySelector('.rudi-app-inject');
    if (injectNode) {
        injectNode.classList.remove('rudi-app-inject');
        injectNode.classList.remove('disabled');
        injectNode.classList.add('rudi-app-interaction');
        injectNode.setAttribute("id", idString);
        const inputNode = DomHelper.appendInputText(injectNode, 'rudi-ldapquery-form', ['rudi-inline-icon'], [], 'username', '', '', []);
        const btnNode = DomHelper.appendNodeAsSibling(inputNode, 'button', ['btn', 'btn-primary'], []);
        DomHelper.appendNode(btnNode, 'i', ['fa-light', 'fa-paper-plane'], []);
        btnNode.addEventListener('click', (event) => {
            if (DEBUG)
                console.log('query clicked');
            let hostname = inputNode.value;
            renderContent(cardNode, username, bearerToken, injectNode, hostname, idString);
        });
        inputNode.addEventListener('keypress', (event) => {
            if (event.key == 'Enter') {
                let hostname = inputNode.value;
                renderContent(cardNode, username, bearerToken, injectNode, hostname, idString);
            }
        });
    }
}
